import { createElement, useEffect, useState, type FC } from 'react'
import { createPortal } from 'react-dom'
import { useTranslation } from 'react-i18next'
import Icon from '@/components/common/Icon'
import Notification from '@/components/common/Notification'
import { useShortcut } from './useShortcut'

export const useSaveShortcutNotification = (): {
  readonly View: FC
} => {
  const isSaving = useShortcut(
    (evt) => (evt.metaKey || evt.ctrlKey) && evt.key.toLowerCase() === 's'
  )
  const [isVisible, setIsVisible] = useState(false)
  const [animationKey, setAnimationKey] = useState(0)

  useEffect(() => {
    if (isSaving) {
      // Restart animation by changing key (forces re-render and animation restart)
      setAnimationKey((prev) => prev + 1)
      setIsVisible(true)
    }
  }, [isSaving])

  const View: FC = () => {
    const { t } = useTranslation()

    if (!isVisible) return null

    return createPortal(
      createElement(
        Notification,
        {
          key: animationKey,
          className: 'animate-notification-slide',
          onAnimationEnd: () => {
            setIsVisible(false)
          },
        },
        createElement(Icon, { name: 'informationCircle' }),
        t('ls_save_shortcut_toast')
      ),
      document.body
    )
  }

  return { View }
}
